import { Routes } from '@angular/router';
import { authGuard } from './core/guards/auth.guard';
import { LayoutComponent } from './shared/components/layout/layout.component';

export const routes: Routes = [
  {
    path: '',
    loadComponent: () => import('./features/landing/landing.component').then(m => m.LandingComponent),
    pathMatch: 'full',
    title: 'ParseEasy — AI Document Parsing API'
  },
  {
    path: '',
    loadChildren: () => import('./features/marketing/marketing.routes').then(m => m.MARKETING_ROUTES)
  },
  {
    path: 'auth',
    loadChildren: () => import('./features/auth/auth.routes').then(m => m.AUTH_ROUTES)
  },
  {
    path: 'organization-suspended',
    loadComponent: () => import('./features/auth/organization-suspended/organization-suspended.component').then(m => m.OrganizationSuspendedComponent),
    title: 'Organization Suspended'
  },
  {
    path: 'parseeasy/docs',
    loadChildren: () => import('./features/api-documentation/api-documentation.routes').then(m => m.API_DOCUMENTATION_ROUTES)
  },
  {
    path: '',
    component: LayoutComponent,
    canActivate: [authGuard],
    children: [
      {
        path: 'dashboard',
        loadChildren: () => import('./features/dashboard/dashboard.routes').then(m => m.DASHBOARD_ROUTES),
        data: { title: 'Dashboard' }
      },
      {
        path: 'documents',
        loadChildren: () => import('./features/documents/documents.routes').then(m => m.DOCUMENTS_ROUTES),
        data: {
          title: 'Documents',
          pageSubtitle: 'View and manage processed documents.'
        }
      },
      {
        path: 'activity',
        loadChildren: () => import('./features/activity/activity.routes').then(m => m.ACTIVITY_ROUTES),
        data: { title: 'Activity' }
      },
      {
        path: 'playground',
        loadChildren: () => import('./features/playground/playground.routes').then(m => m.PLAYGROUND_ROUTES),
        data: { title: 'Playground' }
      },
      {
        path: 'examples',
        loadChildren: () => import('./features/examples/examples.routes').then(m => m.EXAMPLES_ROUTES),
        data: { title: 'Examples' }
      },
      {
        path: 'api-keys',
        loadChildren: () => import('./features/api-keys/api-keys.routes').then(m => m.API_KEYS_ROUTES),
        data: { title: 'API Keys' }
      },
      {
        path: 'templates',
        loadChildren: () => import('./features/templates/templates.routes').then(m => m.TEMPLATES_ROUTES),
        data: { title: 'Templates' }
      },
      {
        path: 'analytics',
        loadChildren: () => import('./features/analytics/analytics.routes').then(m => m.ANALYTICS_ROUTES),
        data: { title: 'Analytics' }
      },
      {
        path: 'settings',
        loadChildren: () => import('./features/settings/settings.routes').then(m => m.SETTINGS_ROUTES),
        data: { title: 'Settings' }
      },
      {
        path: 'billing',
        loadChildren: () => import('./features/billing/billing.routes').then(m => m.BILLING_ROUTES),
        data: {
          title: 'Billing & Credits',
          pageSubtitle: 'Manage your plan, page credits, and usage in one place.'
        }
      },
      {
        path: 'webhooks',
        loadChildren: () => import('./features/webhooks/webhooks.routes').then(m => m.webhookRoutes),
        data: { title: 'Webhooks' }
      },
      {
        path: 'usage-reports',
        loadChildren: () => import('./features/usage-reports/usage-reports.routes').then(m => m.USAGE_REPORTS_ROUTES),
        data: {
          title: 'Usage Reports',
          pageSubtitle: 'Track consumption, success rate, and processing history for your workspace.'
        }
      },
      {
        path: 'support',
        loadChildren: () => import('./features/support/support.routes').then(m => m.SUPPORT_ROUTES),
        data: {
          title: 'Support',
          pageSubtitle: 'View and manage your support tickets'
        }
      },
      {
        path: 'help',
        loadChildren: () => import('./features/help/help.routes').then(m => m.HELP_ROUTES),
        data: {
          title: 'Help',
          pageSubtitle: 'Guides to set up your workspace, parse documents, and use the API.'
        }
      }
    ]
  },
  {
    path: '**',
    redirectTo: '/'
  }
];
